export interface MembershipData {
    active_plan: ActivePlan,
    subscription_features: SubscriptionFeatures
}

export interface Plan {
    id: number;
    name: string;
    created_at: string;
    updated_at: string;
    flag: boolean;
    default: boolean;
    sort_order: number;
    featured: boolean;
    description: string | null;
    color?: string;
    frequencies?: {
        [K in SubscriptionFrequencies]: FrequencyDetail
    },
    features: {
        [key: string] : null | FeatureValue
    }
}

export interface FeatureValue {
    values?: any,
    value?: any
}

export interface ActivePlan {
    id: number;
    user_id: number;
    membership_plan_id: number;
    created_at: string;
    updated_at: string;
    flag: boolean;
    membership_plan_billing_frequency_id: number | null;
    start_date: string;
    end_date: string;
    razorpay_plan_id: string | null;
    razorpay_subscription_id: string | null;
    billing_amount: number | null;
    billing_frequency: string | null;
    billing_cycle: string | null;
    status: string;
    uuid: string;
    platform: any;
    platform_reference: string | null;
    plan_frequency: string | null;
    plan: Plan;
    billing_frequency_name: string | null;
    started_date: string;
    next_due_date: string;
}

export interface SubscriptionFeature {
    id: number;
    name: string;
    slug: string;
    type: string;
    created_at?: string;
    updated_at?: string;
    flag?: boolean;
    sort_order: number;
    description: string | null;
    applicable_limit?: number | boolean;
    consumed_limit?: number | boolean;
    allow_usage?: boolean;
    is_visible?: boolean;
}

export interface SubscriptionFeatures {
    applications: SubscriptionFeature;
    profile_insights: SubscriptionFeature;
    post_insights: SubscriptionFeature;
    higher_visibility: SubscriptionFeature;
    profile_recommendation: SubscriptionFeature;
}


export enum SubscriptionFrequencies {
    MONTHLY = "monthly",
    QUARTERLY = "quarterly",
    HALF_YEARLY = "half_yearly",
    ANNUALLY = "annually"
}

// Interface for Frequency Details
export interface FrequencyDetail {
    id: number;
    monthly_amount: string;
    amount: string;
    name: string;
    original_amount: string;
    discount: number;
    apple_product_id?: string;
  }

export interface ActivePlanShort {
    uuid: string,
    plan: Plan,
    plan_frequency: {
        frequency_slug: SubscriptionFrequencies
    } | null
}

export interface PricingData {
    frequencies: {
        [K in SubscriptionFrequencies] : string
    },
    features: SubscriptionFeature[],
    plans: Plan[],
    allow_start: boolean,
    active_plan: ActivePlanShort,
    membership_profiles?: {
        pictures?: string[],
        count: number
    }
}

export interface ApplePricingData {
    apple_product_id: string
}

export interface MembershipCheckoutData {
    ump: {
        uuid: string,
        platform_reference: {
            razorpay_order_id?: any,
            razorpay_subscription_id?: any,
            apple_product_id?: any,
        },
        platform: string,
    },
    checkout: {
        key: string,
        plan_name: string
    }
}